import { Component, Input } from '@angular/core';
import { CommonService } from '@core/services/common-service/common.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent {

  @Input() cardTitle!: string;
  @Input() cardDetails!: any;
  @Input() requesterShortName!: string;
  @Input() requesterFullName!: string;
  @Input() showReqName!: boolean;
  @Input() showUpdateBtn!: boolean;
  downloadProofSubscription!: Subscription;

  constructor(private commonService: CommonService) { }

  /** Track by functionality for ngFor iteration */
  trackByFn(index: number, cardDetail: any): number {
    return cardDetail.id;
  }

  /** Download update lastname proof document */
  downloadFile(filename: any) {
    let downloadProofReqParam = {
      fileName: filename
    }
    this.downloadProofSubscription = this.commonService.getUpdateProof(downloadProofReqParam).subscribe((downloadProofData: any) => {
      window.open(downloadProofData, "_blank");
    }, (error: any) => {
    });
  }

}
